<template>
	<!--<section class="blocks" :style="{ background: bg_color }">-->
	<section class="blocks" id="block8" style="background: #ffffff">
		<div class="container">
			<article>
				<h2 class="title-box">{{ title }}</h2>

				<div class="content" v-html="content">
					{{ content }}
				</div>

				<!--<p style="text-align: center">
				  <strong>
					Quer tomar decisões com menos riscos e mais inteligentes para a estratégia da sua empresa?
				  </strong>
				</p>
				<p></p>

				<div class="leftBlock">
				  <p>
					Business Intelligence é um método tecnológico desenvolvido para dar suporte a gestão de negócios ajudando as empresas a tomar as melhores decisões para seu crescimento.
				  </p>
				  <p>
					É a inteligência na coleta, organização, análise, compartilhamento e monitoramento de uma grande quantidade de dados brutos que, através do uso de metodologias, processos e tecnologias, são transformados em informações relevantes para tomadas de decisões estratégicas.
				  </p>
				</div>

				<div class="rightBlock">
				  <ul>
					<li>•  Big Data analítico</li>
					<li>•  Análise das informações feita por cientistas de dados.</li>
					<li>•  Análise da Experiência do Usuário.</li>
					<li>•  Relatórios customizados.</li>
					<li>•  Previsões e insights.</li>
					<li>•  Proposição de negócios.</li>
					<li>•  Busca por resultados reais ($$$$) através de ações consistentes e nada  invasivas, baseadas na ciência de dados.</li>
				  </ul>
				</div>-->
			</article>

		</div>
	</section>
</template>

<script>
    export default {
        props: ["title", "content", "figure", "bg_color"]
    }
</script>

<style lang="scss">
	#block8 {

		article {
			display: flex;
			flex-basis: 100%;
			flex-wrap: wrap;
			justify-content: space-between;

			h2 {
				flex-basis: 100%;
			}

			ul {
				li {
					color: #222831;
					font-size: 1.6em;
					line-height: 24px;
					margin-bottom: 5px;
					text-align: left;
				}
			}

			p {
				flex-basis: 100%;
				text-align: left;
			}

			.content {
				display: flex;
				flex-basis: 100%;
				justify-content: space-between;
				flex-wrap: wrap;

				.title {
					width: 100%;
				}

				.leftBlock, .rightBlock {
					flex-basis: 48%;
				}

				p {
					text-align: left;
				}
			}

			h2 {
				margin-bottom: 80px;
			}

			.left-block {
				flex-basis: 50%;
				margin-top: 10px;
			}

			figure {
				flex-basis: 50%;
				padding: 0;
			}

			p {
				color: #222831;
				font-size: 1.6em;
				line-height: 24px;
				margin-bottom: 25px;
				text-align: left;
			}
		}
	}

	@media (max-width: 640px) {
		#block8 {
			article {
				.content {

					div {
						padding: 0 !important;

						p {
							text-align: left !important;
						}
					}

					.leftBlock {
						flex-basis: 100%;
						padding-left: 0 !important;
					}

					.rightBlock {
						flex-basis: 100%;
					}
				}
			}
		}
	}
</style>




// WEBPACK FOOTER //
// src/components/shared/blocks/Block8.vue